import { Stack, styled } from '@mui/material'
import { Redirect } from 'react-router'
import { useAction } from '../../containers/accountCreateCompletion/accountCreateCompletionService'
import { getAccountCreateSteps } from '../../containers/common/codeMaster'
import { identityVerificationUrl, rootUrl, faqUrl } from '../../containers/common/constant/appUrl'
import { accountCreateStep } from '../../containers/common/constant/classification'
import { translate } from '../../i18n'
import { AttentionLabel } from '../components/common/attentionLabel'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonOutlinedResponsive } from '../components/common/buttons/buttonOutlinedResponsive'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { GContainer, GItem, GItemContainer, RowSpacerGItem } from '../components/common/grids'
import { Form } from '../components/common/inputs/form'
import { TextBox } from '../components/common/inputs/textBox'
import { StepBar } from '../components/common/stepBar'
import { Link } from '../components/common/link'

const SubMessageGItem = styled(GItem)({
  whiteSpace: 'pre-wrap',
})
const MainMessageLabel = styled('span')(({ theme }) => ({
  fontSize: theme.typography.font.sizeL2,
}))

export const AccountCreateCompletion = () => {
  const { isVerifiedEmail, formMethods, resendEmailResultCode, onSubmit } = useAction()

  if (isVerifiedEmail) {
    return <Redirect to={identityVerificationUrl.url()} />
  }
  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <GContainer>
          <GItem md={3}></GItem>
          <GItem xs={12} md={6}>
            <StepBar activeStepValue={accountCreateStep.step3} stepValueLabels={getAccountCreateSteps()} />
            <GContainer>
              <GItem xs={12}>
                <MainMessageLabel>{translate('accountCreateCompletion.text.mainMessage')}</MainMessageLabel>
              </GItem>
              <RowSpacerGItem />

              <SubMessageGItem xs={12}>{translate('accountCreateCompletion.text.subMessageMail')}</SubMessageGItem>
              <RowSpacerGItem />
              <SubMessageGItem xs={12}>
                {translate('accountCreateCompletion.text.subMessageQaLinkPrefix')}
                <Link to={faqUrl.url()} target="_blank">{translate('accountCreateCompletion.text.subMessageQaLink')}</Link>
                {translate('accountCreateCompletion.text.subMessageQaLinkSuffix')}
              </SubMessageGItem>
              <RowSpacerGItem />
              <GItemContainer xs={12}>
                <GItem xs={12}>
                  <AttentionLabel>*</AttentionLabel>
                  {translate('accountCreateCompletion.label.email')}
                </GItem>
                <GItem xs={12}>
                  <TextBox
                    name="email"
                    label={translate('accountCreateCompletion.label.email')}
                    maxLength={320}
                    textType="email"
                    required
                  />
                </GItem>
              </GItemContainer>
              <GItemContainer xs={12}>
                <GItem xs={12}>
                  <AttentionLabel>*</AttentionLabel>
                  {translate('accountCreateCompletion.label.emailConfirmation')}
                </GItem>
                <GItem xs={12}>
                  <TextBox
                    name="emailConfirmation"
                    label={translate('accountCreateCompletion.label.emailConfirmation')}
                    maxLength={320}
                    textType="email"
                    required
                    autoComplete="off"
                  />
                </GItem>
              </GItemContainer>

              {!!resendEmailResultCode && (
                <>
                  <RowSpacerGItem />
                  <GItem xs={12}>
                    <ErrorMessageCard
                      messages={[
                        translate(`accountCreateCompletion.error.resendEmailResultCode${resendEmailResultCode}`),
                      ]}
                    />
                  </GItem>
                </>
              )}
            </GContainer>
          </GItem>
          <GItem md={3}></GItem>
        </GContainer>

        <BottomButtonGroup>
          <ButtonOutlinedWarningL fullWidth type="submit">
            {translate('accountCreateCompletion.button.resend')}
          </ButtonOutlinedWarningL>
          <ButtonOutlinedResponsive to={rootUrl.url()}>
            {translate('system.button.backToHome')}
          </ButtonOutlinedResponsive>
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}
